import { ValueAndCauseDTO, CommunicationDTO, VatAndPaymentDTO, CounterExpertiseDTO, RemarkDTO, SigningDTO, SvsDTOLine, SvsReportRequest } from '../../../business/models/dto/svs/svs.dto';

import api from './api';

const svsUrl = '/svs';

export function getSvsAdditionalData(instructionId: number) {
  return api.get(`${svsUrl}/additional/${instructionId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function getSvsList(instructionId: number) {
  return api.get(`${svsUrl}/items/${instructionId}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function getSvs(id: number) {
  return api.get(`${svsUrl}/${id}`).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveValueAndCause(svsId: number, instructionId: number, data: ValueAndCauseDTO) {
  return api.post(`${svsUrl}/value-and-cause`, {
    id: svsId,
    instructionId: instructionId,
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveVatAndPayment(svsId: number, instructionId: number, data: VatAndPaymentDTO) {
  return api.post(`${svsUrl}/vat-and-payment`, {
    id: svsId,
    instructionId: instructionId,
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveCounterExpertise(svsId: number, instructionId: number, data: CounterExpertiseDTO) {
  return api.post(`${svsUrl}/counter-expertise`, {
    id: svsId,
    instructionId: instructionId,
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveCommunication(svsId: number, instructionId: number, data: CommunicationDTO) {
  return api.post(`${svsUrl}/communication`, {
    id: svsId,
    instructionId: instructionId,
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveRemark(svsId: number, instructionId: number, data: RemarkDTO) {
  return api.post(`${svsUrl}/remark`, {
    id: svsId,
    instructionId: instructionId,
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function saveSigning(svsId: number, instructionId: number, data: SigningDTO, locked: boolean) {
  return api.post(`${svsUrl}/signing`, {
    id: svsId,
    instructionId: instructionId,
    data: data,
    locked: locked
  }).catch(err => {
    console.error(err);
    return err;
  });
}


export function saveSvsLines(svsId: number, instructionId: number, excessApplicable: boolean | undefined, underCondition: boolean | undefined, data: SvsDTOLine[]) {
  return api.post(`${svsUrl}/lines`, {
    id: svsId,
    instructionId: instructionId,
    excessApplicable: excessApplicable,
    underCondition: underCondition,
    data: data
  }).catch(err => {
    console.error(err);
    return err;
  });
}

export function generateReports(request: SvsReportRequest) {
  return api.post(`${svsUrl}/generate-reports`, request).catch(err => {
    console.error(err);
    return err;
  });
}
